module.exports = __webpack_public_path__ + "img/auth0.54900768.png";